import { observer } from 'mobx-react-lite'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { useNotificationsChannel } from 'hooks/useNotificationsChannel'
import { ViewTypes } from 'stores/NotificationsStore'
import { useRootStore } from 'stores/RootStore'
import Styles from './NotificationsTray.module.scss'
import { ReadNotifications } from './ReadNotifications'
import { UnreadNotifications } from './UnreadNotifications'
import { getTotalCountFromInfiniteQuery } from 'utils/query'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { Bell, BellInactive } from 'blaze-ui/icons'
import { Counter, CounterSize, CounterVariant } from 'blaze-ui/Counter/Counter'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useNotificationsQuery } from './hooks/useNotificationsQuery'
import { Props } from './NotificationsTrayContainer'

export const NotificationsTray = observer(({ trigger, counterVariant }: Props) => {
  const { notifications } = useRootStore()
  const currentView = notifications.currentView
  const unseenNotificationsQuery = useNotificationsQuery({ items: 1, read: false, seen: false })
  const unseenCount = getTotalCountFromInfiniteQuery(unseenNotificationsQuery)

  useNotificationsQuery({ items: 1, read: true })
  useNotificationsChannel()

  const handlePress = () => {
    notifications.setCurrentView(currentView ? null : ViewTypes.Unread)
  }

  const onClose = ({ onPopoverClose }: { onPopoverClose: () => void }) => {
    notifications.setCurrentView(null)
    onPopoverClose()
  }

  let icon = Bell
  if (notifications.mutedAt) icon = BellInactive

  return (
    <DropdownTrigger
      placement="bottom-end"
      popoverClassName={Styles.popover}
      containFocus={false}
      onClose={() => notifications.setCurrentView(null)}
    >
      <Tooltip label="Notifications">
        <div className={Styles.triggerButton}>
          {unseenCount > 0 && (
            <div className={Styles.counter}>
              <Counter count={unseenCount} variant={counterVariant || CounterVariant.Tertiary} size={CounterSize.xs} />
            </div>
          )}
          {trigger || (
            <IconButton
              size="lg"
              variant={'tertiary'}
              onPress={handlePress}
              rounded
              icon={icon}
              aria-label="Notifications"
            />
          )}
        </div>
      </Tooltip>
      {(onPopoverClose) =>
        currentView === ViewTypes.Read ? (
          <ReadNotifications onClose={() => onClose({ onPopoverClose })} />
        ) : (
          <UnreadNotifications
            onClose={() => onClose({ onPopoverClose })}
            isShowAllReadDisabled={notifications.read.length < 1}
          />
        )
      }
    </DropdownTrigger>
  )
})
